export default __webpack_public_path__ + "img/tiny-9.5520d173.jpg";